import TemplateIcon from '@heroicons/react/outline/TemplateIcon'

import type { I18nShape } from '@tribeplatform/react-components/i18n'
import {
  BlockType,
  RegisteredBlockConfig,
} from '@tribeplatform/react-slate-kit/types'

import { NavbarPreview } from './NavbarPreview'
import { NavbarProps } from './types'

export const NavBarConfig: (
  intl: I18nShape,
) => RegisteredBlockConfig<NavbarProps> = ({ $t }) => ({
  type: BlockType.Block,
  Icon: <TemplateIcon />,
  Preview: NavbarPreview,
  displayName: $t({
    defaultMessage: 'Top navigation',
    id: 'Blocks.TopNavigation.DisplayName',
  }),
  removable: false,
  usable: false,
  availabilityConditions: {
    header: true,
  },
})
